// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GenerateSignInOAuthUrlQueryVariables = Types.Exact<{
  state: Types.Scalars['String']['input'];
  redirectUri: Types.InputMaybe<Types.Scalars['Url']['input']>;
  codeChallenge: Types.InputMaybe<Types.Scalars['String']['input']>;
  loginHint: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GenerateSignInOAuthUrlQuery = { __typename?: 'Query' } & Pick<Types.Query, 'generateSignInOAuthUrl'>;

export const GenerateSignInOAuthUrlDocument = /*#__PURE__*/ gql`
    query generateSignInOAuthUrl($state: String!, $redirectUri: Url, $codeChallenge: String, $loginHint: String) {
  generateSignInOAuthUrl(
    state: $state
    redirectUri: $redirectUri
    codeChallenge: $codeChallenge
    loginHint: $loginHint
  )
}
    `;

/**
 * __useGenerateSignInOAuthUrlQuery__
 *
 * To run a query within a React component, call `useGenerateSignInOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateSignInOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateSignInOAuthUrlQuery({
 *   variables: {
 *      state: // value for 'state'
 *      redirectUri: // value for 'redirectUri'
 *      codeChallenge: // value for 'codeChallenge'
 *      loginHint: // value for 'loginHint'
 *   },
 * });
 */
export function useGenerateSignInOAuthUrlQuery(
  baseOptions: Apollo.QueryHookOptions<GenerateSignInOAuthUrlQuery, GenerateSignInOAuthUrlQueryVariables> &
    ({ variables: GenerateSignInOAuthUrlQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GenerateSignInOAuthUrlQuery, GenerateSignInOAuthUrlQueryVariables>(
    GenerateSignInOAuthUrlDocument,
    options,
  );
}
export function useGenerateSignInOAuthUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GenerateSignInOAuthUrlQuery, GenerateSignInOAuthUrlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GenerateSignInOAuthUrlQuery, GenerateSignInOAuthUrlQueryVariables>(
    GenerateSignInOAuthUrlDocument,
    options,
  );
}
// @ts-expect-error
export function useGenerateSignInOAuthUrlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GenerateSignInOAuthUrlQuery, GenerateSignInOAuthUrlQueryVariables>,
): Apollo.UseSuspenseQueryResult<GenerateSignInOAuthUrlQuery, GenerateSignInOAuthUrlQueryVariables>;
export function useGenerateSignInOAuthUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GenerateSignInOAuthUrlQuery, GenerateSignInOAuthUrlQueryVariables>,
): Apollo.UseSuspenseQueryResult<GenerateSignInOAuthUrlQuery | undefined, GenerateSignInOAuthUrlQueryVariables>;
export function useGenerateSignInOAuthUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GenerateSignInOAuthUrlQuery, GenerateSignInOAuthUrlQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GenerateSignInOAuthUrlQuery, GenerateSignInOAuthUrlQueryVariables>(
    GenerateSignInOAuthUrlDocument,
    options,
  );
}
export type GenerateSignInOAuthUrlQueryHookResult = ReturnType<typeof useGenerateSignInOAuthUrlQuery>;
export type GenerateSignInOAuthUrlLazyQueryHookResult = ReturnType<typeof useGenerateSignInOAuthUrlLazyQuery>;
export type GenerateSignInOAuthUrlSuspenseQueryHookResult = ReturnType<typeof useGenerateSignInOAuthUrlSuspenseQuery>;
